
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Malignant_melanoma_of_head_and_neck',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Malignant_melanoma_of_head_and_neck.vue